export default {
  namespaced: true,
  training: {
    title: "Capacitaciones",
    training_topic: "Temática de Capacitación",
    number_of_guests: "Cantidad de personas invitadas",
    number_of_attendees: "Cantidad de personas asistentes",
    cost: "Costo",
    supplier_name: "Nombre del proveedor",
    add_training: "Agregar Capacitación",
    center: "Centro",
    sector: "Sector",
    region: "Región",
    type: "Tipo",
    mode: "Modalidad",
    confirm_cancel: "¿Estás seguro de que deseas cancelar esta capacitación?",
    canceled: "Capacitación cancelada"
  }
};
